import React from "react";
import { BRAND } from "../brand";

// GAMEFLOW logo wordmark using the cropped "G" PNG icon.
// size = "sm" (28px), "md" (36px), "lg" (44px)
export default function BrandMark({ size = "md", whiteText = false, hideText = false, className = "" }) {
  const dim = size === "sm" ? 28 : size === "lg" ? 44 : 36;
  const txtSize = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={BRAND.logoIcon}
        alt="GAMEFLOW"
        width={dim}
        height={dim}
        loading="eager"
        className="rounded-xl shadow-neon-soft object-cover"
        style={{ width: dim, height: dim }}
      />
      {!hideText && (
        <span className={`font-display ${txtSize} font-bold tracking-tight ${whiteText ? "text-white" : "text-[#0F0F14]"}`}>
          GAME<span className="text-[#A855F7]">FLOW</span>
        </span>
      )}
    </div>
  );
}
